import React, { useState } from "react"
import clsx from "clsx"

import { Tooltip, VirtualList } from "components"
import LinkSpecificationSearch from "./StrmrmfsSearch"
import classes from "./StrmrmfsCategories.module.scss"

const StrmrmfsCategories = props => {
  const {
    categories,
    selectedCategory,
    setSelectedCategory
  } = props

  const [cats, setCats] = useState(categories)

  const handleSearch = (search) => {
    setCats(
      categories.filter(c => c.name.includes(search))
    )
  }

  const handleSelectCategory = (categoryId) => {
    setSelectedCategory(prev =>
      prev === categoryId ? "" : categoryId
    )
  }

  return (
    <div className={classes["container"]}>
      <LinkSpecificationSearch
        delay={0}
        placeholder="جست و جوی..."
        onSearch={handleSearch}
      />
      <VirtualList
        keyField="_id"
        data={cats}
        itemHeight={28}
        className={classes["list"]}
        listEmptyComponent={
          <div className={classes["no"]}>
            هیچ دسته بندی یافت نشد
          </div>
        }
        renderItem={(category) =>
          <div
            onClick={() => handleSelectCategory(category._id)}
            className={
              clsx(
                classes["category"],
                selectedCategory === category._id && classes["active"]
              )
            }
          >
            <Tooltip
              title={category.name}
            >
              <div className={classes["category-name"]}>
                {category.name}
              </div>
            </Tooltip>
          </div>
        }
      />
    </div>
  )
}

export default StrmrmfsCategories